import React, { useRef, useState, useEffect } from "react";
import Tooltip from "@mui/material/Tooltip";
import "./EllipsedCell.css";

const EllipsedCell = ({ value, scrollContainerRef = null }) => {
  const textRef = useRef(null);
  const [isEllipsed, setIsEllipsed] = useState(false);
  const [tooltipOpen, setTooltipOpen] = useState(false);
  const scrollTimerRef = useRef(null);

  useEffect(() => {
    const el = textRef.current;
    if (el && typeof value === "string") {
      setIsEllipsed(Math.ceil(el.scrollWidth) > Math.ceil(el.clientWidth));
    } else {
      setIsEllipsed(false);
    }
  }, [value]);

  useEffect(() => {
    const container =
      scrollContainerRef?.current ? scrollContainerRef.current : window;

    const handleScroll = () => {
      setTooltipOpen(false);
      if (scrollTimerRef.current) clearTimeout(scrollTimerRef.current);
      scrollTimerRef.current = setTimeout(() => {
        scrollTimerRef.current = null;
      }, 150);
    };

    container.addEventListener?.("scroll", handleScroll, { passive: true });
    container.addEventListener?.("wheel", handleScroll, { passive: true });

    return () => {
      container.removeEventListener?.("scroll", handleScroll);
      container.removeEventListener?.("wheel", handleScroll);
      if (scrollTimerRef.current) clearTimeout(scrollTimerRef.current);
    };
  }, [scrollContainerRef]);

  const handleOpen = () => {
    if (!isEllipsed || scrollTimerRef.current) return;
    setTooltipOpen(true);
  };

  const handleClose = () => setTooltipOpen(false);

  return (
    <Tooltip
      title={isEllipsed ? value : ""}
      placement="top"
      arrow
      disableInteractive
      enterDelay={300}
      leaveDelay={0}                         
      open={tooltipOpen}
      onOpen={handleOpen}
      onClose={handleClose}
      componentsProps={{ tooltip: { sx: { fontSize: "1rem" } } }}
      TransitionProps={{ timeout: 0 }}     
    >
      <span
        ref={textRef}
        className="ec-text"
        tabIndex={isEllipsed ? 0 : -1}
        onMouseEnter={handleOpen}
        onMouseLeave={handleClose}
        onFocus={handleOpen}
        onBlur={handleClose}
      >
        {value}
      </span>
    </Tooltip>
  );
};

export default EllipsedCell;
